<script lang="ts">
	import { getContext } from 'svelte';
	import { _ } from 'svelte-i18n';
	import Icon from '../../Icon.svelte';
	import {
		FilterCondition,
		buildFilterValue,
		type FilterOption,
		type SimpleListContext
	} from '../../../types/ListTypes';

	const { updateFilterActivityState } = getContext<SimpleListContext>('enzianListContext');

	interface Props {
		//The whole information with the filterType
		filterOption: FilterOption;
	}

	let { filterOption = $bindable() }: Props = $props();

	let showDropdown = $state(false);
	let booleanValue: boolean | null = $derived(parseString(filterOption.value));
	let filterCondition: FilterCondition = filterOption.booleanOption?.useExistMode
		? FilterCondition.N
		: FilterCondition.EQ;

	function handleFilterChange() {
		if (booleanValue == null) {
			filterOption.value = null;
		} else {
			//Update the external value. We will send null in case of false in exists mode
			filterOption.value = buildFilterValue(booleanValue, filterCondition);
		}

		updateFilterActivityState();
	}

	function parseString(value: string | null): boolean | null {
		//Read value back in.
		if (value != null && value != 'null') {
			const values = value.split('|');
			return values.length >= 2 ? values[0] == 'true' : null;
		} else {
			return null;
		}
	}
</script>

<div class="relative">
	<button
		class="outline-none w-full h-full border-2 dark:bg-dark-400 bg-white
		px-2 rounded
		 border-gray dark:border-dark-300
		 hover:border-secondary-300 dark:hover:border-secondary-500"
		style="min-height: 44px;"
		onblur={() => {
			setTimeout(() => {
				showDropdown = false;
			}, 200);
		}}
		onclick={() => {
			showDropdown = !showDropdown;
		}}
	>
		<div class="flex items-center p-2">
			<p class="grow text-left truncate">
				{booleanValue == null
					? $_('basic_components.bool_filter.all')
					: booleanValue == true
						? $_('basic_components.bool_filter.only')
						: $_('basic_components.bool_filter.exclusive')}
			</p>

			<Icon name="chevron-down" size="small" classInfo="ml-4 dark:fill-white" />
		</div>
	</button>

	{#if showDropdown}
		<div
			style="max-height: 200px; min-width: 100%;"
			class="absolute bg-white outline-none border border-gray rounded shadow-xl z-40 flex flex-col overflow-y-auto"
		>
			<!--Null-->
			<button
				class="opt"
				onclick={() => {
					booleanValue = null;
					handleFilterChange();
				}}
			>
				<p>{$_('basic_components.bool_filter.all')}</p>
			</button>
			<!--False-->
			<button
				class="opt"
				onclick={() => {
					booleanValue = false;

					handleFilterChange();
				}}
			>
				<p>{$_('basic_components.bool_filter.exclusive')}</p>
			</button>
			<!--True-->
			<button
				class="opt"
				onclick={() => {
					booleanValue = true;
					handleFilterChange();
				}}
			>
				<p>{$_('basic_components.bool_filter.only')}</p>
			</button>
		</div>
	{/if}
</div>

<style>
	.opt :global {
    border-left-width: 2px;
    border-color: transparent;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.opt :global:hover {
    --tw-border-opacity: 1;
    border-color: rgb(45 218 255 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1))
}
.opt :global:where(.dark, .dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(125 125 125 / var(--tw-bg-opacity, 1))
}
.opt :global:hover:where(.dark, .dark *) {
    --tw-border-opacity: 1;
    border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1))
}
</style>
